import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { HttpParams } from '@capacitor/core';
import { HttpService } from './http.service';
import { ApiReturnUtilisateurL } from 'src/app/utils/interfaces';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class UtilisateursService {

  constructor(
    private httpService: HttpService,
    private dataService: DataService,
  ) { }

  fetchUtilisateurListe(token: string, siteId: number): Observable<ApiReturnUtilisateurL[]> {
    const params: HttpParams = { site_id: `${siteId}` };
    const _header: [string, string][] = [['Authorization', `Bearer ${token}`]];
    return this.httpService.apiGet<ApiReturnUtilisateurL[]>({ uriTail: `/utilisateurs/list` }, _header, params);    
  }

  prepareUtilisateursListe(utilisateursListe: ApiReturnUtilisateurL[]): Promise<ApiReturnUtilisateurL[]> {
    return new Promise((resolve, reject) => {
      resolve(utilisateursListe);
    });
  }

  storeUtilisateurListe(utilisateurListe: ApiReturnUtilisateurL[]): Promise<ApiReturnUtilisateurL[]> {
    return this.dataService.usersValidations.set(utilisateurListe);
  }

  getUtilisateurListeInfos(): Observable<ApiReturnUtilisateurL[] | null> {
    return this.dataService.usersValidations.get();
  }

  getUtilisateurListeInfosAsPromise(): Promise<ApiReturnUtilisateurL[] | null> {
    return firstValueFrom(this.getUtilisateurListeInfos());
  }

}
